import {
  BarcodeImporter,
  EmailPolling,
  FtpPolling,
  ProcessDefinition,
  ProcessDefinitionAutomatedIndexing,
  ProcessDefinitionAutomatedIndexingCreateAndEditScenario,
  ProcessDefinitionCreateForm,
  ProcessDefinitionDetails,
  ProcessDefinitionDriverSettlements,
  ProcessDefinitionFormDetails,
  ProcessDefinitionGeneralPayables,
  ProcessDefinitionGeneralPayablesApprovals,
  ProcessDefinitionMaintenancePayables,
  ProcessDefinitionOrderEntry,
  ProcessDefinitionPrintRender,
  ProcessDefinitionScanning,
  ProcessDefinitionScanningDetails,
  ProcessEditor,
} from 'app/routes/lazyPages';
import ROUTES from 'app/routes/paths';
import { ACCESSIBLE_ROLES } from 'constants/roles';
import { LicensedModule } from 'hocs/accessibleByLicense/typing';
import onlySignedInPage from 'hocs/onlySignedInPage';
import {
  accessOrDefaultRedirect,
  licenseOrDefaultRedirect,
} from 'utils/accessOrDefaultRedirect';

export const definitionRoutes: RoutesConfig = [
  {
    path: ROUTES.process.definition._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(ProcessDefinition)
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.editProcess.preview._(),
      ROUTES.process.editProcess._(),
      ROUTES.process.editProcess.forms._(),
      ROUTES.process.editProcess.forms.create(),
      ROUTES.process.editProcess.forms.edit(),
      ROUTES.process.editProcess.forms.details._(),
      ROUTES.process.editProcess.emailTemplates._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(ProcessEditor)
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.definition.details.version._(),
      ROUTES.process.definition.details._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionDetails
      )
    ),
    exact: false,
  },
  {
    path: [
      ROUTES.process.createProcessForm(),
      ROUTES.process.editProcessForm(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionCreateForm
      )
    ),
    exact: false,
  },
  {
    path: [
      ROUTES.process.formDetails.preview(),
      ROUTES.process.formDetails._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionFormDetails
      )
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.scanningDetails.preview(),
      ROUTES.process.scanningDetails._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionScanningDetails
      )
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.definition.services.printRender.preview._(),
      ROUTES.process.definition.services.printRender._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionPrintRender
      )
    ),
    exact: false,
  },
  {
    path: [
      ROUTES.process.definition.services.scanning.preview._(),
      ROUTES.process.definition.services.scanning._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionScanning
      )
    ),
    exact: false,
  },
  {
    path: [
      ROUTES.process.definition.services.ftpPolling.preview._(),
      ROUTES.process.definition.services.ftpPolling._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(FtpPolling)
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.definition.services.emailPolling.preview._(),
      ROUTES.process.definition.services.emailPolling._(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(EmailPolling)
    ),
    exact: true,
  },
  {
    path: [ROUTES.process.definition.services.automatedIndexing._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.AUTOMATED_INDEXING)(
          ProcessDefinitionAutomatedIndexing
        )
      )
    ),
    exact: true,
  },
  {
    path: [
      ROUTES.process.definition.services.automatedIndexing.createScenario(),
      ROUTES.process.definition.services.automatedIndexing.editScenario(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.AUTOMATED_INDEXING)(
          ProcessDefinitionAutomatedIndexingCreateAndEditScenario
        )
      )
    ),
    exact: false,
  },
  {
    path: [ROUTES.process.definition.services.barcodeImporter._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(BarcodeImporter)
    ),
    exact: true,
  },
  {
    path: [ROUTES.process.definition.services.orderEntry._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.ORDER_ENTRY)(
          ProcessDefinitionOrderEntry
        )
      )
    ),
    exact: false,
  },
  {
    path: [ROUTES.process.definition.services.maintenancePayables._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.MAINTENANCE_PAYABLES)(
          ProcessDefinitionMaintenancePayables
        )
      )
    ),
    exact: false,
  },
  {
    path: [ROUTES.process.definition.services.generalPayables._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.GENERAL_PAYABLES)(
          ProcessDefinitionGeneralPayables
        )
      )
    ),
    exact: false,
  },
  {
    path: [ROUTES.process.definition.services.generalPayablesApprovals._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        licenseOrDefaultRedirect(LicensedModule.GENERAL_PAYABLES)(
          ProcessDefinitionGeneralPayablesApprovals
        )
      )
    ),
    exact: true,
  },
  {
    path: [ROUTES.process.definition.services.driverSettlements._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(
        ProcessDefinitionDriverSettlements
      )
    ),
    exact: false,
  },
];
